import { Result } from 'antd'
import React from 'react'

export default function Home () {
  const supportLink = (
    <a href='https://app.slack.com/client/E07UHBYP7PW/C02NQ5TCSC9'>
      suporte
    </a>
  )

  return (
    <Result
      status="warning"
      title="Serviço descontinuado!"
      subTitle={
        <>
          Para mais informações, acesse o {supportLink}.
        </>
      }
    />
  )
}
